"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilterMethod = getFilterMethod;
exports.setFilterMethod = setFilterMethod;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var methodMap = {
  number: [{
    label: 'types.equals',
    value: 'eq',
    inputs: {
      tag: 'mh-input-number'
    }
  }, {
    label: 'types.notEqual',
    value: 'ne',
    inputs: {
      tag: 'mh-input-number'
    }
  }, {
    label: 'types.gt',
    value: 'gt',
    inputs: {
      tag: 'mh-input-number'
    }
  }, {
    label: 'types.gte',
    value: 'gte',
    inputs: {
      tag: 'mh-input-number'
    }
  }, {
    label: 'types.lt',
    value: 'lt',
    inputs: {
      tag: 'mh-input-number'
    }
  }, {
    label: 'types.lte',
    value: 'lte',
    inputs: {
      tag: 'mh-input-number'
    }
  }],
  string: [{
    label: 'types.includes',
    value: 'regex',
    inputs: {
      tag: 'mh-input'
    },
    beforeFilter: function beforeFilter(text) {
      return text && text.trim();
    }
  }],
  labelValue: [{
    label: 'types.includes',
    value: 'in',
    inputs: {
      tag: 'mh-select',
      optionValue: '{{children.optionValue}}',
      optionLabel: '{{children.optionLabel}}',
      options: '{{children.options}}',
      changeOnSelect: true,
      type: '{"type":"array","items":{"type":"labelValue","path":"children.options"}}'
    }
  }, {
    label: 'types.equals',
    value: 'eq',
    inputs: 'children'
  } // {
  //   label: '不等于',
  //   value: 'ne',
  //   inputs: 'children',
  // },
  // {
  //   label: '包含',
  //   value: 'regex',
  //   inputs: { tag: 'mh-input' },
  // },
  ],
  cascadeLabelValue: [{
    label: 'types.equals',
    value: 'in',
    inputs: {
      tag: 'mh-cascader',
      optionValue: '{{children.optionValue}}',
      optionLabel: '{{children.optionLabel}}',
      parentKey: '{{children.parentKey}}',
      options: '{{children.options}}',
      changeOnSelect: true,
      type: 'selectAllChildren',
      showSearch: '{{children.showSearch}}'
    }
  }],
  date: [// {
  //   label: 'types.equals',
  //   value: 'eq',
  //   inputs: 'children',
  // },
  // {
  //   label: '不等于',
  //   value: 'ne',
  //   inputs: [
  //     'children',
  //   ],
  // },
  {
    label: 'types.range',
    value: 'between',
    inputs: {
      tag: 'mh-range-picker',
      format: '{{children.format}}',
      time: '{{children.time}}'
    }
  }],
  array: [{
    label: 'types.equals',
    value: 'eq',
    inputs: 'children'
  }],
  boolean: [{
    label: 'types.equals',
    value: 'eq',
    inputs: {
      tag: 'mh-radio-group',
      options: [{
        label: '是',
        value: true
      }, {
        label: '否',
        value: false
      }]
    }
  }]
};

function getFilterMethod(name) {
  var cm = methodMap[name];
  var out = [// {
    //   label: '为空',
    //   value: 'eqNull',
    // },
    // {
    //   label: '不为空',
    //   value: 'neNull',
    // },
  ];

  if (cm) {
    return [].concat((0, _toConsumableArray2.default)(cm), out);
  }

  return out;
}

function setFilterMethod(name, filterMethod) {
  methodMap[name] = filterMethod;
}